const UserPermission = Object.freeze({
  PERMS_LOGIN_AS_OTHER: 'PERMS_LOGIN_AS_OTHER',
  PERMS_MANAGE_MESSAGE: 'PERMS_MANAGE_MESSAGE',
  PERMS_MANAGE_COMPANY: 'PERMS_MANAGE_COMPANY',
  PERMS_MANAGE_ACCOUNT: 'PERMS_MANAGE_ACCOUNT',
  PERMS_MANAGE_USER: 'PERMS_MANAGE_USER',
  PERMS_API_INTERNAL: 'PERMS_API_INTERNAL',
  PERMS_VIEW_ACCOUNT: 'PERMS_VIEW_ACCOUNT',
  PERMS_WORKBENCH2_BASIC: 'PERMS_WORKBENCH2_BASIC',
  PERMS_GLOBAL_REPORT: 'PERMS_GLOBAL_REPORT',
  PERMS_MANAGE_DASHBOARD: 'PERMS_MANAGE_DASHBOARD',
  PERMS_VIEW_CB2THEME: 'PERMS_VIEW_CB2THEME',
  PERMS_MANAGE_CB2THEME: 'PERMS_MANAGE_CB2THEME',
  PERMS_MANAGE_CB2TOPIC: 'PERMS_MANAGE_CB2TOPIC',
  PERMS_LIVE_REPORT: 'PERMS_LIVE_REPORT',
  PERMS_MANAGE_LIVE_REPORT: 'PERMS_MANAGE_LIVE_REPORT',
  PERMS_SHARE_TOPIC_WITH_COMPANY: 'PERMS_SHARE_TOPIC_WITH_COMPANY',
  PERMS_MANAGE_SOCIAL_WEB: 'PERMS_MANAGE_SOCIAL_WEB',
  PERMS_RESYNDICATION: 'PERMS_RESYNDICATION',
  PERMS_MANAGE_FIREHOSE: 'PERMS_MANAGE_FIREHOSE',
  PERMS_MANAGE_SOCIAL_MEDIA_COVERAGE: 'PERMS_MANAGE_SOCIAL_MEDIA_COVERAGE',
  PERMS_MANAGE_AUDIENCE: 'PERMS_MANAGE_AUDIENCE',
  PERMS_MANAGE_ANNOTATION: 'PERMS_MANAGE_ANNOTATION',
  PERMS_NETBASE_PRO: 'PERMS_NETBASE_PRO',
  PERMS_INTERNAL_DATA: 'PERMS_INTERNAL_DATA',
  PERMS_INTERNAL_ANALYSIS: 'PERMS_INTERNAL_ANALYSIS',
  PERMS_FILE_MAPPER: 'PERMS_FILE_MAPPER',
  PERMS_API_BASIC: 'PERMS_API_BASIC',
  PERMS_INSIGHT_API_RETRIEVE_SENTENCES_AND_DOCUMENTS:
    'PERMS_INSIGHT_API_RETRIEVE_SENTENCES_AND_DOCUMENTS',
  PERMS_INSIGHT_API_RETRIEVE_SENTENCES_AND_DOCUMENTS_COMMON_DATA_MAX_PAY_LOAD:
    'PERMS_INSIGHT_API_RETRIEVE_SENTENCES_AND_DOCUMENTS_COMMON_DATA_MAX_PAY_LOAD',
  PERMS_INSIGHT_API_RETRIEVE_SENTENCES_AND_DOCUMENTS_REDDIT_MAX_PAY_LOAD:
    'PERMS_INSIGHT_API_RETRIEVE_SENTENCES_AND_DOCUMENTS_REDDIT_MAX_PAY_LOAD',
  PERMS_BATCH_TOPIC_THEME_OPERATIONS: 'PERMS_BATCH_TOPIC_THEME_OPERATIONS',
  PERMS_AI: 'PERMS_AI',
  PERMS_EXPORT_PDF: 'PERMS_EXPORT_PDF'
})
export default UserPermission
export type UserPermissionStrings = typeof UserPermission[keyof typeof UserPermission]
// RESERVE BELOW
